import { useEffect, useState, useCallback } from "react";
import socket from "../../socket";
import { checkBullFinish, checkBullTurn } from "../../helper/scoring/utils";

const useBullSocket = (
  isChallenger,
  scoreHistory,
  fetchUserScore,
  handleSetTurn
) => {
  const [opponentHistory, setOpponentHistory] = useState([]);
  const [isFinish, setIsFinish] = useState(false);

  const handleBullUpdate = useCallback(
    async (data) => {
      if (opponentHistory.length === 0) {
        await fetchUserScore();
      }
      setOpponentHistory((prev) => [...prev, Number(data.score) || 0]);
    },
    [opponentHistory.length, fetchUserScore]
  );

  useEffect(() => {
    if (checkBullFinish(scoreHistory, opponentHistory)) {
      setIsFinish(true);
    }
  }, [scoreHistory, opponentHistory]);

  useEffect(() => {
    const userTurn = checkBullTurn(
      scoreHistory.length,
      opponentHistory.length,
      isChallenger,
      isFinish
    );
    handleSetTurn(userTurn);
  }, [
    scoreHistory.length,
    opponentHistory.length,
    isChallenger,
    isFinish,
    handleSetTurn,
  ]);

  useEffect(() => {
    socket.on("bull-update-response", handleBullUpdate);
    return () => {
      socket.off("bull-update-response", handleBullUpdate);
    };
  }, [handleBullUpdate]);

  return { opponentHistory, isFinish };
};

export default useBullSocket;
